import { cn } from '../../lib/utils'

export function SegmentedControl<T extends string>({
  label,
  value,
  options,
  isDark,
  onChange,
}: {
  label: string
  value: T
  options: Array<{ value: T; label: string }>
  isDark: boolean
  onChange: (value: T) => void
}) {
  return (
    <fieldset className="flex min-w-0 items-center gap-2 border-0 p-0">
      <legend
        className={cn(
          'float-left text-xs font-medium',
          isDark ? 'text-neutral-400' : 'text-neutral-600',
        )}
      >
        {label}
      </legend>
      <div
        className={cn(
          'flex rounded-lg border p-0.5',
          isDark ? 'border-white/[0.08] bg-surface-2' : 'border-neutral-200 bg-neutral-50',
        )}
      >
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-pressed={value === option.value}
            onClick={() => onChange(option.value)}
            className={cn(
              'aw-search-control min-w-16 rounded-md px-3 py-1.5 text-xs font-medium transition-colors',
              value === option.value
                ? 'bg-brand-600 text-white'
                : isDark
                  ? 'text-neutral-400 hover:text-neutral-200'
                  : 'text-neutral-600 hover:text-neutral-900',
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </fieldset>
  )
}

export function EmptyState({
  title,
  detail,
  isDark,
}: {
  title: string
  detail: string
  isDark: boolean
}) {
  return (
    <div
      className={cn(
        'rounded-lg border p-6 text-center',
        isDark ? 'border-white/[0.06] bg-surface-1' : 'border-neutral-200 bg-white',
      )}
    >
      <p className={cn('text-sm font-medium', isDark ? 'text-neutral-200' : 'text-neutral-900')}>
        {title}
      </p>
      <p className={cn('mt-1 text-xs', isDark ? 'text-neutral-500' : 'text-neutral-500')}>
        {detail}
      </p>
    </div>
  )
}
